import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_all: FaireCategoryEntity = {
  token: "cat_home-decor-all",
  type: "category",
  name: "All home decor",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
